(function () {
  'use strict';

  function initNtnwLandingPage() {
  var forms = document.querySelectorAll('[data-ntnw-product-form]');
  var carousels = document.querySelectorAll('[data-ntnw-carousel]');
  var bookPreviews = document.querySelectorAll('[data-ntnw-book-preview]');
  if (!forms.length && !carousels.length && !bookPreviews.length) return;

  var prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealTargets = document.querySelectorAll('.ntnw-landing > .ntnw-section');

  function getHashTarget(hash) {
    var id = hash ? hash.slice(1) : '';

    if (!id) return null;

    try {
      id = decodeURIComponent(id);
    } catch (error) {
      return null;
    }

    return document.getElementById(id);
  }

  function revealHashTarget(hash) {
    var target = getHashTarget(hash);
    var revealTarget = null;

    if (!target) return;

    if (target.classList && target.classList.contains('fade-in')) {
      revealTarget = target;
    } else if (target.closest) {
      revealTarget = target.closest('.fade-in');
    }

    if (revealTarget) {
      revealTarget.classList.add('is-visible');
    }
  }

  if (!prefersReduce && 'IntersectionObserver' in window) {
    revealTargets.forEach(function (el) {
      el.classList.add('fade-in');
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.18 });

    revealTargets.forEach(function (el) {
      observer.observe(el);
    });
  }

  revealHashTarget(window.location.hash);

  window.addEventListener('hashchange', function () {
    revealHashTarget(window.location.hash);
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.ntnw-landing a[href^="#"]');

    if (!link) return;

    revealHashTarget(link.getAttribute('href'));
  }, true);

  function initCarousels() {
    carousels.forEach(function (carousel) {
      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-ntnw-carousel-slide]'));
      var thumbs = Array.prototype.slice.call(carousel.querySelectorAll('[data-ntnw-carousel-thumb]'));
      var prev = carousel.querySelector('[data-ntnw-carousel-prev]');
      var next = carousel.querySelector('[data-ntnw-carousel-next]');
      var indexEl = carousel.querySelector('[data-ntnw-carousel-index]');
      var currentIndex = 0;

      if (!slides.length) return;

      function setSlide(nextIndex) {
        currentIndex = (nextIndex + slides.length) % slides.length;

        slides.forEach(function (slide, index) {
          var isActive = index === currentIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        thumbs.forEach(function (thumb, index) {
          var isActive = index === currentIndex;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        if (indexEl) {
          indexEl.textContent = String(currentIndex + 1).padStart(2, '0');
        }
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          setSlide(Number(thumb.dataset.index || 0));
        });
      });

      if (prev) {
        prev.addEventListener('click', function () {
          setSlide(currentIndex - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          setSlide(currentIndex + 1);
        });
      }

      setSlide(0);
    });
  }

  function initBookPreviews() {
    bookPreviews.forEach(function (preview) {
      var pages = Array.prototype.slice.call(preview.querySelectorAll('[data-ntnw-book-page]'));
      var thumbs = Array.prototype.slice.call(preview.querySelectorAll('[data-ntnw-book-thumb]'));
      var prev = preview.querySelector('[data-ntnw-book-prev]');
      var next = preview.querySelector('[data-ntnw-book-next]');
      var titleEl = preview.querySelector('[data-ntnw-book-title]');
      var indexEl = preview.querySelector('[data-ntnw-book-index]');
      var openCurrent = preview.querySelector('[data-ntnw-book-open-current]');
      var modal = preview.querySelector('[data-ntnw-book-modal]');
      var modalImage = preview.querySelector('[data-ntnw-book-modal-image]');
      var modalCaption = preview.querySelector('[data-ntnw-book-modal-caption]');
      var modalClose = preview.querySelector('[data-ntnw-book-close]');
      var modalPrev = preview.querySelector('[data-ntnw-book-modal-prev]');
      var modalNext = preview.querySelector('[data-ntnw-book-modal-next]');
      var currentIndex = 0;

      if (!pages.length) return;
      preview.dataset.ntnwBookReady = 'true';

      function pageNumber(index) {
        return String(index + 1).padStart(2, '0');
      }

      function getPageData(index) {
        var page = pages[index];
        var image = page ? page.querySelector('img') : null;

        return {
          alt: image ? image.alt : '',
          number: page ? page.dataset.pageNumber || pageNumber(index) : pageNumber(index),
          src: image ? image.getAttribute('src') : '',
          title: page ? page.dataset.pageTitle || '' : ''
        };
      }

      function updateModal() {
        if (!modal || modal.hidden || !modalImage) return;

        var data = getPageData(currentIndex);
        modalImage.src = data.src;
        modalImage.alt = data.alt;

        if (modalCaption) {
          modalCaption.textContent = 'Page ' + data.number + ' · ' + data.title;
        }
      }

      function setPage(nextIndex) {
        currentIndex = (nextIndex + pages.length) % pages.length;
        preview.dataset.ntnwBookCurrent = String(currentIndex);

        pages.forEach(function (page, index) {
          var isActive = index === currentIndex;
          var isSpreadNext = index === currentIndex + 1;
          page.classList.toggle('is-active', isActive);
          page.classList.toggle('is-spread-next', isSpreadNext);
          page.setAttribute('aria-hidden', isActive || isSpreadNext ? 'false' : 'true');
        });

        thumbs.forEach(function (thumb, index) {
          var isActive = index === currentIndex;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        var data = getPageData(currentIndex);

        if (titleEl) {
          titleEl.textContent = data.title;
        }

        if (indexEl) {
          indexEl.textContent = data.number;
        }

        updateModal();
      }

      function openModal(index) {
        if (!modal) return;

        setPage(index);
        modal.hidden = false;
        document.documentElement.classList.add('ntnw-modal-open');
        updateModal();

        if (modalClose) {
          modalClose.focus();
        }
      }

      function closeModal() {
        if (!modal) return;

        modal.hidden = true;
        document.documentElement.classList.remove('ntnw-modal-open');
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          setPage(Number(thumb.dataset.index || 0));
        });
      });

      pages.forEach(function (page, index) {
        var opener = page.querySelector('[data-ntnw-book-open-page]');
        if (!opener) return;

        opener.addEventListener('click', function () {
          openModal(index);
        });
      });

      if (prev) {
        prev.addEventListener('click', function () {
          setPage(currentIndex - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          setPage(currentIndex + 1);
        });
      }

      if (openCurrent) {
        openCurrent.addEventListener('click', function () {
          openModal(currentIndex);
        });
      }

      if (modalClose) {
        modalClose.addEventListener('click', closeModal);
      }

      if (modalPrev) {
        modalPrev.addEventListener('click', function () {
          setPage(currentIndex - 1);
        });
      }

      if (modalNext) {
        modalNext.addEventListener('click', function () {
          setPage(currentIndex + 1);
        });
      }

      if (modal) {
        modal.addEventListener('click', function (event) {
          if (event.target === modal) {
            closeModal();
          }
        });

        document.addEventListener('keydown', function (event) {
          if (modal.hidden) return;

          if (event.key === 'Escape') {
            closeModal();
          } else if (event.key === 'ArrowLeft') {
            setPage(currentIndex - 1);
          } else if (event.key === 'ArrowRight') {
            setPage(currentIndex + 1);
          }
        });
      }

      setPage(0);
    });
  }

  initCarousels();
  initBookPreviews();

  if (!forms.length) return;

  function getCartNotification() {
    return document.querySelector('cart-notification');
  }

  function getSectionsToRender() {
    var sections = ['cart-notification-product', 'cart-notification-button'];

    if (document.getElementById('cart-icon-bubble')) {
      sections.push('cart-icon-bubble');
    }

    return sections;
  }

  function parseSection(html, selector) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var el = parsed.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  function renderCartNotification(parsedState) {
    if (!parsedState || !parsedState.sections) return;

    var cartNotification = getCartNotification();
    var productTarget = document.getElementById('cart-notification-product');
    var buttonTarget = document.getElementById('cart-notification-button');
    var bubbleTarget = document.getElementById('cart-icon-bubble');

    if (productTarget && parsedState.sections['cart-notification-product']) {
      var productHtml = parseSection(parsedState.sections['cart-notification-product'], '#cart-notification-product-' + parsedState.id);
      if (productHtml) productTarget.innerHTML = productHtml;
    }

    if (buttonTarget && parsedState.sections['cart-notification-button']) {
      var buttonHtml = parseSection(parsedState.sections['cart-notification-button'], '#cart-notification-button');
      if (buttonHtml) buttonTarget.innerHTML = buttonHtml;
    }

    if (bubbleTarget && parsedState.sections['cart-icon-bubble']) {
      var bubbleHtml = parseSection(parsedState.sections['cart-icon-bubble'], '#cart-icon-bubble');
      if (bubbleHtml) bubbleTarget.innerHTML = bubbleHtml;
    }

    if (cartNotification) {
      cartNotification.productId = parsedState.id;
    }
  }

  function openCart() {
    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
      window.Rebuy.SmartCart.show();
      return;
    }

    if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.show === 'function') {
      window.Rebuy.Cart.show();
      return;
    }

    var cartNotification = getCartNotification();
    if (cartNotification && typeof cartNotification.open === 'function') {
      cartNotification.open();
      return;
    }

    window.location.href = '/cart';
  }

  function setLoading(form, isLoading) {
    var button = form.querySelector('[data-ntnw-submit]');
    if (!button) return;

    if (isLoading) {
      button.setAttribute('disabled', 'disabled');
      button.classList.add('is-loading');
    } else {
      button.removeAttribute('disabled');
      button.classList.remove('is-loading');
    }
  }

  function showError(form, message) {
    var errorEl = form.querySelector('[data-ntnw-form-error]');
    if (!errorEl) return;

    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  }

  function buildPayload(form) {
    var formData = new FormData(form);
    var payload = {};

    formData.forEach(function (value, key) {
      payload[key] = value;
    });

    payload.sections = getSectionsToRender();
    payload.sections_url = window.location.pathname;

    return payload;
  }

  function getCartAddUrl(form) {
    var cartAddUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : form.action;

    if (cartAddUrl && cartAddUrl.indexOf('/cart/add.js') === -1) {
      cartAddUrl = cartAddUrl.replace(/\/cart\/add\/?$/, '/cart/add.js');
    }

    return cartAddUrl || '/cart/add.js';
  }

  function fallbackErrorMessage() {
    return window.cartStrings && window.cartStrings.error || 'Unable to add this item to cart.';
  }

  function parseJsonResponse(responseText) {
    if (!responseText) return {};
    return JSON.parse(responseText);
  }

  function getErrorMessage(responseText) {
    try {
      var body = parseJsonResponse(responseText);
      return body.description || body.message || fallbackErrorMessage();
    } catch (error) {
      return fallbackErrorMessage();
    }
  }

  function requestCartAdd(url, payload) {
    return new Promise(function (resolve, reject) {
      var request = new XMLHttpRequest();

      request.open('POST', url, true);
      request.setRequestHeader('Content-Type', 'application/json');
      request.setRequestHeader('Accept', 'application/json');

      request.onload = function () {
        if (request.status >= 200 && request.status < 300) {
          try {
            resolve(parseJsonResponse(request.responseText));
          } catch (error) {
            reject(new Error(fallbackErrorMessage()));
          }
        } else {
          reject(new Error(getErrorMessage(request.responseText)));
        }
      };

      request.onerror = function () {
        reject(new Error(fallbackErrorMessage()));
      };

      request.send(JSON.stringify(payload));
    });
  }

  function addToCart(form) {
    if (form.dataset.ntnwSubmitting === 'true') return;

    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.value) {
      showError(form, 'This product is not available yet.');
      return;
    }

    form.dataset.ntnwSubmitting = 'true';

    var cartNotification = getCartNotification();
    if (cartNotification && typeof cartNotification.setActiveElement === 'function') {
      cartNotification.setActiveElement(document.activeElement);
    }

    showError(form, '');
    setLoading(form, true);

    requestCartAdd(getCartAddUrl(form), buildPayload(form))
      .then(function (parsedState) {
        renderCartNotification(parsedState);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: parsedState }));
        openCart();
      })
      .catch(function (error) {
        showError(form, error.message);
      })
      .finally(function () {
        form.dataset.ntnwSubmitting = 'false';
        setLoading(form, false);
      });
  }

  function handleFormIntent(event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    addToCart(event.currentTarget);
  }

  function handleButtonIntent(event) {
    var form = event.currentTarget.closest('[data-ntnw-product-form]');
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    addToCart(form);
  }

  function handleDocumentButtonIntent(event) {
    var button = event.target.closest && event.target.closest('[data-ntnw-submit]');
    if (!button) return;

    var form = button.closest('[data-ntnw-product-form]');
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    addToCart(form);
  }

  function handleDocumentSubmitIntent(event) {
    var form = event.target.closest && event.target.closest('[data-ntnw-product-form]');
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    addToCart(form);
  }

  document.addEventListener('click', handleDocumentButtonIntent, true);
  document.addEventListener('submit', handleDocumentSubmitIntent, true);

  forms.forEach(function (form) {
    var submitButton = form.querySelector('[data-ntnw-submit]');
    form.addEventListener('submit', handleFormIntent, true);

    if (submitButton) {
      submitButton.addEventListener('click', handleButtonIntent, true);
    }
  });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNtnwLandingPage, { once: true });
  } else {
    initNtnwLandingPage();
  }
})();
